import React from 'react';
import { useMutation, useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { GroupBase, OptionsOrGroups } from 'react-select';
import api from '../../../../components/api';
import { yupErrorMsg } from '../../../../components/atoms/const';

export interface PlanogramData {
  'extension': boolean,
  'vmId': number,
  'price': number,
  'productName': string,
  'apCode': string,
  'quantity': number,
  'isDrink': boolean,
  'rowNumber': number,
  'productId': number,
  'productUpc': string,
  'productImage': string,
  'maxCount': number,
  'slots': number,
  'sprialCount': number,
  'id': string
}

export interface VmRes {
  'removed': boolean;
  'clientName': string;
  'model': string;
  'deviceId': string;
  'nickName': string;
  'location': string;
  'id': string;
  'type': string;
}

export interface Product {
  'description': string;
  'isBatch': boolean,
  'upc': string,
  'samsClubItemNum': null,
  'productId': null,
  'unit': number,
  'image': string;
  'vistarItemNum': null;
  'name': string;
  'id': number;
}

function useVmPlanogram() {
  const isCoffee: boolean = React.useMemo(() => window.location.pathname.split('/')[1] === 'coffee-machine', [window.location.pathname]);
  const isWholesale: boolean = React.useMemo(() => window.location.pathname.split('/')[1] === 'wholesale', [window.location.pathname]);
  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Get Initial Data
  * handling Header value from Real Time Database by VmId that are can get from url params
  * url format : vending-machine/planogram/:vmId
  */
  const { vmId } = useParams();
  const { data: vmRes } = useQuery(
    ['getById', 'vendingMachines', vmId],
    () => api.vendingMachine.getById(vmId!),
    {
      enabled: !!vmId,
    },
  );
  const vmData: any = React.useMemo(() => vmRes?.data?.data, [vmRes]);

  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Change UI Style
  * Because there are 2 type of model in Figma, this state will handle
  * which component that would be use for rendering
  * 1. six-square for RenderSixSquareStyle.tsx
  * 2. menu for RenderMenuStyle.tsx
  */
  const [currentMode, setCurrentMode] = React.useState<1 | 2>(1);

  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Filter Product List
  * This maybe different with another search bar, because you dont need to click
  * enter to do filter. But it will work same like another
  * Did this because there are no API for filtering
  */
  const { data: planogramListRes, isLoading: planogramListLoading, refetch: refetchPlanogramList } = useQuery(
    ['getPlanogramByVmId', 'vendingMachines', vmId],
    () => api.vendingMachine.getPlanogramByVmId(vmId!),
    {
      enabled: !!vmId,
    },
  );

  const [searchValue, setSearchValue] = React.useState<string>('');
  const onChangeSearch = (text: string) => setSearchValue(text);

  const planogramList: PlanogramData[][] | undefined = React.useMemo(() => {
    const resData = planogramListRes?.data?.data;
    if (resData && Object.keys(resData).length !== 0) {
      const list: PlanogramData[][] = Object.values(resData).map((data: any) => data);
      if (list && list.length) return list?.map((data) => data?.filter((x) => x.productName?.toLowerCase()?.includes(searchValue.toLowerCase())));
      return undefined;
    }
    return undefined;
  }, [planogramListRes, searchValue]);

  const [activeClient, setActiveClient] = React.useState(-1);
  const [activeVM, setActiveVM] = React.useState(-1);
  const [selectedVMID, setSelectedVMID] = React.useState<number | string>(-1);

  const [resultCopyVmColumn, setResultCopyVmColumn] = React.useState();

  const { data: planogramListByModel } = useQuery(
    ['getPlanogramBModelmId'],
    () => api.vendingMachine.getPlanogramBModelmId(vmData?.vmModelId!),
    {
      enabled: !!vmData?.vmModelId,
    },
  );

  const { isLoading: loadingUpdateCopyPlanogram, mutate: updateCopyPlanogram } = useMutation(api.vendingMachine.updateCopyPlanogram, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: async (res: any) => {
      setResultCopyVmColumn(res);
    },
    onError: (err: any) => {
      setResultCopyVmColumn(err);
      console.log('err', err);
    },
  });

  const planogramClientList: PlanogramData[][] | undefined = React.useMemo(() => {
    const resData = planogramListByModel?.data?.data;
    return resData;
  }, [planogramListByModel]);

  const handleSelected = (index: number) => {
    setActiveClient(index);
    setActiveVM(-1);
    setSelectedVMID('');
  };

  const handleSelectedVM = (id: any, index: number) => {
    setActiveVM(index);
    setSelectedVMID(id);
  };

  const handleSelectedVMCopy = () => {
    updateCopyPlanogram({
      fromVM: Number(selectedVMID) ?? '',
      toVM: Number(vmId) ?? '',
    });
  };

  const onInitModalCopy = () => {
    setActiveClient(-1);
    setActiveVM(-1);
    setSelectedVMID('');
  };

  const afterCopyVmColumn = async () => {
    await refetchPlanogramList();
    setSelectedVMID('');
    setResultCopyVmColumn(undefined);
  };
  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Search Product
  * This list are needed for editing VM Column later on choosing product,
  * function format must be like this! because we are using Async Select from
  * React Select
  */
  const [productSearchInput, setProductSearchInput] = React.useState<string>('');
  // eslint-disable-next-line no-unused-vars
  const optionsFetcher = (text: string, callback: (options: OptionsOrGroups<{ value: any, label: string }, GroupBase<{ value: string, label: string }>>) => void) => {
    api.product.findAll(text, 0, 25, isWholesale)
      .then((res) => {
        const resData = res?.data?.data;
        if (resData) {
          const options = resData.map((product) => ({
            value: product.id,
            label: product.name,
          }));
          callback(options);
        }
      });
  };
  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Edit VM Column Product
  * Update Real Time Database about Product in Planogram on one column
  * and also help to make sure price and chosen product not empty
  * with formik validation
  */
  const [resultUpdateVmColumn, setResultUpdateVmColumn] = React.useState();
  const { isLoading: loadingUpdateVmColumn, mutate: updateVmColumn } = useMutation(api.vendingMachine.updateColumn, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res: any) => {
      console.log(res);
      setResultUpdateVmColumn(res);
    },
    onError: (err: any) => {
      console.log('err', err);
      setResultUpdateVmColumn(err);
    },
  });
  const { mutate: updateBatchColumn } = useMutation(api.vendingMachine.updateBatchColumn, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res: any) => {
    },
    onError: (err: any) => {
      console.log('err', err);
    },
  });

  const yupSchema = yup.object({
    productId: yup.string().required(yupErrorMsg.PRODUCT_EMPTY),
    price: yup.string().required(yupErrorMsg.PRICE_EMPTY),
  });

  const formik = useFormik({
    initialValues: {
      columnId: '',
      price: '',
      productId: '',
      quantity: '',
      applyAll: false,
      currentProduct: '',
    },
    validationSchema: yupSchema,
    onSubmit: (values) => {
      if (values?.applyAll ?? false) {
        updateVmColumn({
          columnId: values.columnId,
          price: values.price,
          productId: values.productId,
        });
        updateBatchColumn({
          currentProduct: values.currentProduct,
          price: values.price,
          productId: values.productId,
        });
      } else {
        updateVmColumn({
          columnId: values.columnId,
          price: values.price,
          productId: values.productId,
        });
      }
    },
  });

  const [selectedProduct, setSelectedProduct] = React.useState<{ value: number | string, label: string }>();
  const handleChangeSelectedProduct = (e: { value: number | string, label: string } | null) => {
    if (e) {
      setSelectedProduct(e);
      formik.setFieldValue('productId', e.value);
    } else {
      setSelectedProduct(undefined);
      formik.setFieldValue('productId', '');
    }
  };

  const onInitModalEdit = (item: PlanogramData) => {
    if (item.productName !== 'No products') {
      handleChangeSelectedProduct({
        value: item.productId,
        label: item.productName,
      });
    } else {
      handleChangeSelectedProduct(null);
    }
    formik.setFieldValue('quantity', item.quantity);
    formik.setFieldValue('columnId', item.id);
    formik.setFieldValue('price', item.price);
    formik.setFieldValue('currentProduct', item.productId);
    formik.setFieldValue('applyAll', false);
  };

  const afterUpdateVmColumn = async () => {
    await refetchPlanogramList();
    setResultUpdateVmColumn(undefined);
  };

  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Delete VM Column Product
  * Update Real Time Database about Product in Planogram on one column
  */
  const [resultDeleteProduct, setResultDeleteProduct] = React.useState();
  const { isLoading: loadingDeleteProduct, mutate: deleteProduct } = useMutation(api.product.deleteByColumn, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res: any) => {
      console.log(res);
      setResultDeleteProduct(res);
    },
    onError: (err: any) => {
      console.log('err', err);
      setResultDeleteProduct(err);
    },
  });

  const handleDeleteProduct = (columnId: string) => {
    deleteProduct(columnId);
  };

  const afterDeleteProduct = () => {
    setResultDeleteProduct(undefined);
    refetchPlanogramList().catch((e) => alert(e));
  };

  return {
    // Checking Coffee Machine or not
    isCoffee,

    isWholesale,

    // Get VM Data By VM Id
    vmData,
    vmId,

    // Get All Product
    planogramList,
    planogramListLoading,

    // Search Planogram
    onChangeSearch,
    searchValue,

    // Changing Mode on Menu or SixSquare
    currentMode,
    setCurrentMode,

    // Edit Product Column Form
    formik,
    resultUpdateVmColumn,
    loadingUpdateVmColumn,
    afterUpdateVmColumn,
    handleChangeSelectedProduct,
    selectedProduct,
    onInitModalEdit,

    // Delete Product Column
    resultDeleteProduct,
    loadingDeleteProduct,
    handleDeleteProduct,
    afterDeleteProduct,

    // Search Product on Edit Planogram
    optionsFetcher,
    productSearchInput,
    setProductSearchInput,

    // copy
    planogramClientList,
    activeClient,
    activeVM,
    selectedVMID,
    handleSelected,
    handleSelectedVM,
    handleSelectedVMCopy,
    onInitModalCopy,
    resultCopyVmColumn,
    afterCopyVmColumn,
    loadingUpdateCopyPlanogram,
  };
}

export default useVmPlanogram;
